'use client';

import { PortableTextMarkComponentProps } from '@portabletext/react';
import { link } from '@stereoagency/sanity-schema';
import { ReactConfigContext } from '@stereoagency/ui';
import { useContext } from 'react';
import { linkAsProps } from '@/utils';

export default function LinkAnnotationComponent({
  value,
  children
}: PortableTextMarkComponentProps<typeof link.schema.link>) {
  const { config: { LinkComponent } } = useContext(ReactConfigContext);
  const linkProps = linkAsProps(value);

  return <LinkComponent {...linkProps}>{children}</LinkComponent>;
}
